import script from "./Approvals.vue?vue&type=script&setup=true&lang=js"
export * from "./Approvals.vue?vue&type=script&setup=true&lang=js"

import "./Approvals.vue?vue&type=style&index=0&id=7e430c9e&lang=css"

const __exports__ = script;

export default __exports__